<template>
  <div>
    <section
        id="pricing"
        class="cta section">
      <div class="container-herohire">
        <div class="cta-inner">
          <div class="cta-header text-center">
            <h2 class="section-title mt-0">
              Heroes and <span class="text-company-branded">Companies</span>
            </h2>
            <p class="section-paragraph text-light">
              Choose between <span class="text-primary-branded">Hero</span>
              or <span class="text-company-branded">Company</span> when registering, both with their own unique
              features.
              <br>
              <span
                  class="clickable text-primary-2"
                  @click="heroVsCompany">What's the difference?</span>
            </p>
          </div>
        </div>

        <div class="pricing-inner section-inner">
          <div class="pricing-tables-wrap">
            <pricing-table
                type="Premium"
                color="primary"
                title=""
                price="Hero"
                list1="The heart of Hero Hire"
                list2="Appear at the top of each list you've selected"
                list3="Offer your services to the public"/>
            <pricing-table
                type="Company"
                color="company"
                title=""
                price="Company"
                list1="Separate section to other heroes"
                list2="Longer description, more customization options"
                list3="Free Hero Hire sticker for your company window!"/>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PricingTable from "../Templates/Pricing-Table";
import Swal from 'sweetalert2'

export default {
  components: {
    PricingTable
  },
  methods: {
    heroVsCompany() {
      Swal.fire({
        title: 'Heroes vs Companies',
        html: `
          <p class="text-light">
            <span class="text-company-branded">Companies</span> are completely registered companies which have a retail
            space and may have more than one employee. They are shown in a different section of the app.
          </p>
          <p class="text-light">
            <span class="text-primary-branded">Heroes</span> are the individuals that like to fly solo.
          </p>
          <p class="text-light">
            We frequently check to make sure that everybody is registered properly - if you are a company, please don't be
            a villain and pick the right choice! If you are unsure, you may always contact us for some help.
          </p>
          `,
        icon: 'info',
        confirmButtonText: 'Great!',
        customClass: {
          title: 'text-swal-branded',
          popup: 'popup-swal',
          confirmButton: 'button-swal-primary',
          content: 'swal-content'
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.premium-hero-icon {
  position: relative;
  top: 10px;
}

.text-swal-branded {
  color: color(primary, 1) !important;
}

.clickable {
  cursor: pointer;
}

</style>
